import { AfterViewInit, Component, ElementRef, NgZone, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, NgForm, Validators, FormArray } from "@angular/forms";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { AuthService } from "../../main/auth.service";
import { environment } from "../../../environments/environment";
import { ArkUserType, NavigationLinkModel, NavigationLinkViewModel, JwTokenModel, UserModel, PermissionViewModel } from "../../core/api/models";
import { HttpClient, HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { map, tap } from "rxjs/operators";
import { Utils } from "../../core/utils";
import { AlertService } from "../../shared/services/alert.service";
import { NavigationApiService, PermissionsApiService } from "../../core/api/services";
import { Table } from "primeng/table";
import { DomSanitizer } from "@angular/platform-browser";

interface AutoCompleteCompleteEvent {
  originalEvent: Event;
  query: string;
}



@Component({
  selector: 'app-navigation-links-component',
  templateUrl: './navigation-links.component.html',
  standalone: false
})
export class NavigationLinksComponent implements OnInit, AfterViewInit {
  

  public pageTitle: string = 'Navigation Links';

  filter: any = {};
  list: any = undefined;
  loadingList: boolean = true;


  @ViewChild('itemForm') itemForm!: NgForm;

  @ViewChild('dt1') table?: Table;;

  itemFormGroup!: FormGroup;
  currentItem?: NavigationLinkModel;
  loading: boolean = false;


  navigationCategories: any[] | undefined ;
  loadingNavigationCategories: boolean = false;


  permissions: any[] | undefined;
  filteredPermissions: any[] = [];
  loadingPermissions: boolean = false;
  get Categories() {
    return this.itemFormGroup.controls["Categories"] as FormArray;
  }
  get PermissionItems() {
    return this.itemFormGroup.controls["PermissionItems"] as FormArray;
  }

  get IconValue() {
    return this.itemFormGroup.controls["Icon"].value;
  }

  get ImageLocationValue() {
    let url = this.itemFormGroup.controls["ImageLocation"].value;
    if (!url || url.trim().length == 0)
      return;
    return this.getImage(url);
  }

  constructor(private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private alertService: AlertService,
    private apiService: NavigationApiService,
    private permissionsApiService: PermissionsApiService,
    private sanitizer: DomSanitizer,
    private formBuilder: FormBuilder) {
  }


  ngOnInit(): void {


    this.route.paramMap.subscribe((params: ParamMap) => {
      let ID = + ( params.get('ID') || '0');
      if (ID > 0) {
        console.info('Loading ' + ID);

      this.apiService.GetNavigationLink({ body: { id: ID } })
        .forEach(data => {
          this.loadingList = false;
          this.currentItem = data;
          this.load();
        }).catch(
          err => {
            this.alertService.error(Utils.getAjaxError(err));

          });

      }
    });


    this.authService.checkIfAutorized([ArkUserType.Support, ArkUserType.Admin]);


    this.itemFormGroup = this.formBuilder.group(
      {

        //userId: [],
        LinkName: ['', [Validators.required, Validators.maxLength(510)]],
        URL: ['', [Validators.required, Validators.maxLength(250)]],
        Parameter: ['', [Validators.maxLength(250)]],
        Icon: ['', [Validators.maxLength(250)]],
        ImageLocation: ['', [Validators.maxLength(255)]],
        Inactive: [false, []],
        Categories: this.formBuilder.array([]),
        //PermissionIDs: [],
        PermissionItems: this.formBuilder.array([]),
      });
    

  }

  ngAfterViewInit(): void {
    
    /*
    this.filter = {
      filters: {
        "Active": [
          {
            "value": "true",
            "matchMode": "contains",
            "operator": "and"
          }
        ]
      }
    }; 
    ;
    */
    
  }



  loadTable(event: any) {
    if (event || !this.filter) {
      this.filter = Utils.normalizePrimeDatatableEvent(event || this.filter || { filters: {} });
    }

    this.loadingList = true;
    this.apiService.ListNavigationLinks({ body: this.filter })
      .forEach(
        (result) => {
          this.list = result;
          this.loadingList = false;
        }).catch(
          err => {
            this.alertService.error(Utils.getAjaxError(err));
            this.loadingList = false;
          });
  }


  clear(table: Table) {
    this.table = table;
    table.clear();
  }


  addItem(table: Table) {

    this.currentItem = {
      ID: 0,
      Inactive: false
    } as NavigationLinkModel;
    this.load();


  }




  onRowDeleteInit(item: NavigationLinkViewModel) {
    this.alertService.confirm('Confirm', `Are you sure you want to delete ${item.LinkName}?`).subscribe(response => {
      if (response) {
        this.apiService.DeleteNavigationLink({ body: { id: item.ID || 0 } })
          .forEach(
            (ok) => {
              this.loadTable(null);
              this.alertService.success('Item deleted successfully');
            }).catch(
              (err) => {
                this.alertService.error(Utils.getAjaxError(err));
              });

      }
    });

  }


  onRowEditInit(item: NavigationLinkViewModel) {

    this.loadingList = true;


    this.apiService.GetNavigationLink({ body: { id: item.ID || 0 } })
      .forEach(data => {
        this.loadingList = false;
        this.currentItem = data;
        this.load()


      }).catch(
        (err) => {
          this.alertService.error(Utils.getAjaxError(err));
        });

  }

  getItemImage(item: NavigationLinkModel | NavigationLinkViewModel): any {
    return this.getImage(item.ImageLocation);
  }

  getImage(url: string | null | undefined): any {

    if (!url || url?.trim().length==0)
      return null;

    if (url.startsWith("http"))
      return this.sanitizer.bypassSecurityTrustUrl(url);

    if (url.startsWith("/"))
      return this.sanitizer.bypassSecurityTrustUrl(`https://sandbox.optomiser.com${url}`);

    return this.sanitizer.bypassSecurityTrustUrl(`https://sandbox.optomiser.com/images/${url}`);
  }

  

  load() {
    if (!this.currentItem)
      return;

   

    console.info(this.currentItem);
    if (this.itemForm)
      this.itemForm.resetForm();
    if (this.itemFormGroup)
      this.itemFormGroup.clearValidators();

    this.Categories.clear();
    if (this.currentItem.Categories)
      this.currentItem.Categories.forEach(t => {
        var item: FormGroup = this.newCategory();
        this.Categories.push(item);
      });

    this.itemFormGroup.patchValue(this.currentItem);


      /*
    var xPermissions = [] as any[];
    
    if (this.currentItem.Permissions)
      for (var p of this.currentItem.Permissions) {
        this.PermissionItems.push(this.newPermission());
        xPermissions.push({
          PermissionItem: {
            ID: p.PermissionID,
            Permission: p.Permission
          }
        });
    }
    this.itemFormGroup.patchValue({
      PermissionItems: xPermissions
    });
    */
    

    if (this.navigationCategories == undefined) {
      this.loadingNavigationCategories = true;
      this.apiService.ListNavigationCategories({ body: { sortField: 'CategoryName' } }).forEach(data => {
        this.navigationCategories = data.Result || undefined;
        this.loadingNavigationCategories = false;
      })
    }
    if (this.permissions == undefined) {
      this.loadingPermissions = true;
      this.permissionsApiService.List({ body: { sortField: 'Permission' } }).forEach(data => {
        this.permissions = data.Result || undefined;
        this.loadingPermissions = false;
        this.loadItems();
      })
    } else {
      this.loadItems();
    }

 
  }


  loadItems() {

    if (!this.currentItem)
      return;

    this.PermissionItems.clear();
    var xPermissions = [] as any[];
    if (this.currentItem.PermissionIDs)
      for (var p of this.currentItem.PermissionIDs) {
        this.PermissionItems.push(this.newPermission());
        var lookupPermission = this.permissions?.find(x => x.ID == p);
        xPermissions.push({
          PermissionItem: {
            ID: p,
            Permission: lookupPermission?.Permission || 'Permission ' + p,
            PermissionCategory: lookupPermission?.PermissionCategory || null,
            FeatureSwitch: lookupPermission?.FeatureSwitch || null,
            PermissionType: lookupPermission?.PermissionType || null,
          }
        });
      }
    this.itemFormGroup.patchValue({
      PermissionItems: xPermissions
    });


  }
  cancel() {
    this.currentItem = undefined;
    if (this.itemForm)
      this.itemForm.resetForm();
  }

  save() {

    if (!this.itemFormGroup.valid) {

      const errors = Utils.getFormErrors(this.itemFormGroup);

      if (errors.length > 0) {
        this.alertService.error(errors.join(' \n'));
        return;
      }
    }
    var formValue = this.itemFormGroup.getRawValue();
    formValue.PermissionIDs = [];
    //formValue.Permissions = [];
    for (var item of formValue.PermissionItems) {
      if (!item.PermissionItem || !item.PermissionItem.ID || !item.PermissionItem.Permission)
        continue;
      formValue.PermissionIDs.push(item.PermissionItem.ID);
      /*
      formValue.Permissions.push({
        PermissionID: item.PermissionItem.ID,
        Permission: item.PermissionItem.Permission,
      });
      */
    }
    delete formValue.PermissionItems;

    let newItem =
    {
      ...this.currentItem,
      ...formValue
    }
    console.info(newItem);


    this.loading = true;
    this.apiService.SaveNavigationLink({ body: newItem })
      .forEach(
        (savedItem) => {

          this.loading = false;
          this.currentItem = undefined;
          if (this.itemForm)
            this.itemForm.resetForm();
          this.alertService.success('Item saved successfully');
          this.loadTable(null);

        }).catch (
          err => {
            this.loading = false;
            this.alertService.error(Utils.getAjaxError(err));
          
        });


  }


  newCategory() {
    return this.formBuilder.group({
      NavCategoryID: [0],
      OrderNumber: [0],
    });
  }

  addCategory() {
    this.Categories.push(this.newCategory());
  }
  deleteCategory(taskIndex: number) {
    this.Categories.removeAt(taskIndex);
  }




  newPermission() {
    return this.formBuilder.group({
      PermissionItem: [],
    });
  }

  addPermission() {
    this.PermissionItems.push(this.newPermission());
  }
  deletePermission(taskIndex: number) {
    this.PermissionItems.removeAt(taskIndex);
  }
  filterPermission(event: AutoCompleteCompleteEvent) {
    let filtered: any[] = [];
    let query = event.query;
    if (query.indexOf('[') > 0)
      query = query.substring(0, query.indexOf('[')).trim();

    for (let i = 0; i < (this.permissions as any[]).length; i++) {
      let item = (this.permissions as PermissionViewModel[])[i];
      if ((item.Permission && item.Permission.toLowerCase().indexOf(query.toLowerCase()) >= 0)
        || (item.PermissionCategory && item.PermissionCategory.toLowerCase().indexOf(query.toLowerCase()) >= 0)
        || (item.FeatureSwitch && item.FeatureSwitch.toLowerCase().indexOf(query.toLowerCase()) >= 0)) {
        filtered.push(item);
      }
    }
    this.filteredPermissions = filtered;
  }
  labelPermission(item: any) {
    if (!item.FeatureSwitch || item.FeatureSwitch == item.PermissionCategory)
      return `${item.Permission} [${item.PermissionCategory} / ${item.PermissionType}]`;
    return `${item.Permission} [${item.PermissionCategory} - ${item.FeatureSwitch} / ${item.PermissionType}]`;
  }
}
